import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ArtikelGruppenService } from '../../../artikelgruppen/shared/artikelgruppen.service';
import { Artikel } from '../../../store/models/artikel';
import { ArtikelGruppen } from '../../../store/models/artikelgruppen';

@Component({
    selector: 'kkis-app-webshop-main-section1',
    templateUrl: './main-section1.component.html',
    styleUrls: ['./main-section1.component.scss']
})
export class MainSection1Component implements OnInit, OnChanges {

    // Input
    @Input()
    search: string;

    @Input()
    category: string;

    @Input()
    minPreis: number;

    @Input()
    maxPreis: number;

    @Input()
    filterGroessen: string;

    @Input()
    filterFarben: string;

    @Input()
    filterMerkmale: string;

    @Input()
    nurAufLager: boolean = false;

    @Output()
    numberWarenkorbItems: EventEmitter<number> = new EventEmitter<number>(); 

    // Nav
    reihenfolgeTree: ArtikelGruppen.IArtikelGruppeListDto;

    // filter
    minPreisFilter: number;
    maxPreisFilter: number;

    groessen: Artikel.IArtikelListSettingGroessenDto[];
    farben: Artikel.IArtikelListSettingFarbenDto[];
    merkmalGruppen: Artikel.IMerkmalGruppeDto[];

    removeFilter: Artikel.IMerkmalDto;

    // Utils
    isLoading: boolean = true;

    constructor(
        private artikelgruppenService: ArtikelGruppenService,
    ) { }


    ngOnInit(): void {
        this.loadData();
    }

    loadData() {

        this.artikelgruppenService.getListReihenfolgeTree().subscribe(res => {
            this.reihenfolgeTree = res;
            this.isLoading = false;
        });        

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.search != null && changes.search.currentValue != null && changes.search.previousValue != changes.search.currentValue) {
            this.search = changes.search.currentValue;
        }

        if (changes.category != null && changes.category.currentValue != null) {
            if (changes.category.previousValue != changes.category.currentValue)  {
                this.category = changes.category.currentValue;
            }
        }

        if (changes.minPreis != null && changes.minPreis.currentValue != null && changes.minPreis.previousValue != changes.minPreis.currentValue) {
            this.minPreisFilter = changes.minPreis.currentValue;
        }

        if (changes.maxPreis != null && changes.maxPreis.currentValue != null && changes.maxPreis.previousValue != changes.maxPreis.currentValue) {
            this.maxPreisFilter = changes.maxPreis.currentValue;
        }

        if (changes.filterGroessen != null&& changes.filterGroessen.previousValue != changes.filterGroessen.currentValue) {
            this.filterGroessen = changes.filterGroessen.currentValue;
        }

        if (changes.filterFarben != null  && changes.filterFarben.previousValue != changes.filterFarben.currentValue) {
            this.filterFarben = changes.filterFarben.currentValue;
        }

        if (changes.filterMerkmale != null  && changes.filterMerkmale.previousValue != changes.filterMerkmale.currentValue) {
            this.filterMerkmale = changes.filterMerkmale.currentValue;
        }

        if (changes.nurAufLager != null && changes.nurAufLager.currentValue != null && changes.nurAufLager.currentValue != changes.nurAufLager.previousValue) {
            this.nurAufLager = changes.nurAufLager.currentValue;
        }

    }

    getMinPreis(event) {
        this.minPreis = Math.ceil(event);
    }

    getMaxPreis(event) {
        this.maxPreis = Math.ceil(event);
    }

    getGroessen(event) {
        this.groessen = event;
    }

    getFarben(event) {
        this.farben = event;
    }

    getMerkmalGruppen(event) {
        this.merkmalGruppen = event;
    }

    getNumberWarenkorbItems(event) {
        this.numberWarenkorbItems.emit(event);
    }

    getRemoveFilter(event) {

        console.log("main-section.getremovefilter => ", event);

        this.removeFilter = event;
    }
}